import { Users, Mail, Shield, Clock, CheckCircle2, Crown } from 'lucide-react';
import { toast } from 'sonner';

const members = [
  { name: 'Jean-Michel Dupont', email: 'jm.dupont@meridian.global', role: 'Platform Admin', avatar: 'JM', status: 'active', lastActive: '2 min ago', color: '#6366F1' },
  { name: 'J. Mueller', email: 'j.mueller@meridian.global', role: 'AI Risk Owner', avatar: 'JM', status: 'active', lastActive: '15 min ago', color: '#10B981' },
  { name: 'S. Chen', email: 's.chen@meridian.global', role: 'Data Protection Officer', avatar: 'SC', status: 'active', lastActive: '1 hour ago', color: '#F59E0B' },
  { name: 'K. Patel', email: 'k.patel@meridian.global', role: 'Model Steward', avatar: 'KP', status: 'active', lastActive: '3 hours ago', color: '#3B82F6' },
  { name: 'A. Rodriguez', email: 'a.rodriguez@meridian.global', role: 'SOC Analyst Lead', avatar: 'AR', status: 'active', lastActive: '30 min ago', color: '#EF4444' },
  { name: 'L. Nakamura', email: 'l.nakamura@meridian.global', role: 'Compliance Analyst', avatar: 'LN', status: 'active', lastActive: '2 hours ago', color: '#8B5CF6' },
  { name: 'M. Thompson', email: 'm.thompson@meridian.global', role: 'Cloud Security Lead', avatar: 'MT', status: 'invited', lastActive: 'Pending', color: '#64748B' },
];

const activityLog = [
  { time: 'Apr 15, 14:32', user: 'J. Mueller', action: 'Reviewed exception EXC-2026-0041', type: 'review' },
  { time: 'Apr 15, 14:28', user: 'S. Chen', action: 'Exported EU AI Act evidence package', type: 'export' },
  { time: 'Apr 15, 13:55', user: 'K. Patel', action: 'Updated Mistral 7B model card', type: 'update' },
  { time: 'Apr 15, 12:19', user: 'A. Rodriguez', action: 'Escalated alert CS-2026-00441 to IR', type: 'escalate' },
  { time: 'Apr 15, 11:05', user: 'L. Nakamura', action: 'Generated integrity manifest', type: 'export' },
  { time: 'Apr 15, 09:14', user: 'J. Mueller', action: 'Submitted exception request', type: 'create' },
];

export default function TeamManagement() {
  return (
    <div data-testid="team-management" className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="text-sm text-[#94A3B8]">Manage team access and monitor platform activity.</div>
        <button data-testid="invite-member-btn" onClick={() => toast.success('Invitation sent', { description: 'New member will receive an email shortly' })} className="flex items-center gap-2 bg-[#6366F1] hover:bg-[#818cf8] text-white text-xs font-medium px-4 py-2 rounded-lg transition-all shadow-[0_0_8px_rgba(99,102,241,0.15)]">
          <Mail size={13} /> Invite Member
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div className="glass-card p-4"><div className="text-[10px] text-[#475569] uppercase tracking-wider mb-1">Total Members</div><div className="text-2xl font-bold text-[#F8FAFC]">{members.length}</div></div>
        <div className="glass-card p-4"><div className="text-[10px] text-[#475569] uppercase tracking-wider mb-1">Active Now</div><div className="text-2xl font-bold text-[#10B981]">4</div></div>
        <div className="glass-card p-4"><div className="text-[10px] text-[#475569] uppercase tracking-wider mb-1">Pending Invites</div><div className="text-2xl font-bold text-[#F59E0B]">1</div></div>
        <div className="glass-card p-4"><div className="text-[10px] text-[#475569] uppercase tracking-wider mb-1">Roles</div><div className="text-2xl font-bold text-[#F8FAFC]">6</div></div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 glass-card p-6">
          <h3 className="text-sm font-semibold text-[#F8FAFC] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Team Members</h3>
          <div className="space-y-2.5">
            {members.map((m) => (
              <div key={m.email} className="flex items-center gap-3 p-3 rounded-lg bg-[#080D1A] border border-[#1E2A45] hover:border-[#6366F1]/20 transition-colors" data-testid={`member-${m.avatar}`}>
                <div className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0" style={{ backgroundColor: m.color + '30', color: m.color }}>{m.avatar}</div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-[#F8FAFC] font-medium">{m.name}</span>
                    {m.role === 'Platform Admin' && <Crown size={12} className="text-[#F59E0B]" />}
                  </div>
                  <div className="text-[10px] text-[#475569]">{m.email}</div>
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="text-[10px] text-[#94A3B8]">{m.role}</div>
                  <div className="flex items-center gap-1 justify-end mt-0.5">
                    <div className={`w-1.5 h-1.5 rounded-full ${m.status === 'active' ? 'bg-[#10B981]' : 'bg-[#F59E0B]'}`} />
                    <span className="text-[9px] text-[#475569]">{m.lastActive}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card p-6">
          <h3 className="text-sm font-semibold text-[#F8FAFC] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Recent Activity</h3>
          <div className="space-y-3">
            {activityLog.map((a, i) => (
              <div key={i} className="flex items-start gap-2">
                <div className="w-5 h-5 rounded-full bg-[#6366F1]/10 border border-[#6366F1]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Clock size={9} className="text-[#6366F1]" />
                </div>
                <div>
                  <div className="text-[10px] font-mono text-[#475569]">{a.time}</div>
                  <div className="text-xs text-[#94A3B8]"><span className="text-[#F8FAFC] font-medium">{a.user}</span> {a.action}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
